import React from 'react';
import { KurbanReportUIProvider } from '../KurbanReportUIContext';
import { Route, useHistory } from 'react-router-dom';
import KurbanReportDetailCard from './KurbanReportDetailCard';

export function KurbanReportDetailPage({ history }) {
    const History = useHistory()

    const kurbanReportUIEvents = {
        newKurbanReportButtonClick: () => {
            // History.push('/master-data/kurbanReport/new');
            History.push({
                pathname: '/kurbanReport/kurbanReport/new',
                state: {
                    from: History.location.pathname + History.location.search
                }
            })

        },
        openEditKurbanReportPage: (id) => {
            // History.push(`/kurbanReport/kurbanReport/${id}/edit`);
            History.push({
                pathname: `/kurbanReport/kurbanReport/${id}/edit`,
                state: {
                    from: History.location.pathname + History.location.search
                }
            })
        },
    };

    return (
        <KurbanReportUIProvider kurbanReportUIEvents={kurbanReportUIEvents}>
            <KurbanReportDetailCard />
        </KurbanReportUIProvider>
    );
}
